<template>
  <div>
    <HttpContentView :endpoint="utilities.path('communities/@/permissions', communityId)" @response="allPermissions = $event">
      <template v-slot:content>
        <HttpContentView :endpoint="utilities.path('roles/@/permissions', roleId)" @response="rolePermissions = $event" v-model:reload="reload">
          <template v-slot:content>
            <div class="d-flex flex-column g-3">
              <div v-for="module in allPermissions.modules" :key="module.key">
                <h4 class="mb-2">{{ module.name }}</h4>
                <div class="list-group">
                  <HttpFormView :endpoint="utilities.path('roles/@/permissions/@', roleId, permission.key)" v-for="permission in module.permissions" :key="permission.key" method="put" @success="reload = true">
                    <template v-slot:form="{ content, submit }">
                      <div class="list-group-item list-group-item-action" :class="{ disabled: !canModifyPermission(permission) }" @click="content.active = !rolePermissions.includes(permission.key); submit()">
                        <div class="d-flex align-items-center g-2">
                          <CheckboxView color="primary" :active="rolePermissions.includes(permission.key)"/>
                          <span>{{ permission.name }}</span>
                        </div>
                        <div v-if="permission.dependencies && permission.dependencies.length > 0" class="small mt-2">
                          <span class="fw-bold">{{ translate("requires") }}:</span>
                          {{ permission.dependencies.map(dependency => getPermission(dependency)?.name).join(", ") }}
                        </div>
                        <div v-if="permission.dependents && permission.dependents.length > 0" class="small mt-2">
                          <span class="fw-bold">{{ translate("required_by") }}:</span>
                          {{ permission.dependents.map(dependent => getPermission(dependent)?.name).join(", ") }}
                        </div>
                      </div>
                    </template>
                  </HttpFormView>
                </div>
              </div>
            </div>
          </template>
        </HttpContentView>
      </template>
    </HttpContentView>
  </div>
</template>

<script>
import {HttpContentView, HttpFormView, CheckboxView, utilities} from "@niftybit/vue";

export default {
  name: "RolePermissionsView",
  components: {HttpFormView, HttpContentView, CheckboxView},
  props: {
    communityId: String,
    roleId: String
  },
  data() {
    return {
      allPermissions: {},
      rolePermissions: [],
      reload: false,
      filter: undefined
    }
  },
  methods: {
    getPermission(permission) {
      return this.allPermissionsJoined.find(item => item.key === permission.key);
    },
    canModifyPermission(permission) {
      let has = this.rolePermissions.find(item => item === permission.key) !== undefined;
      if (has) {
        if (permission.dependents && permission.dependents.some(dependent => this.rolePermissions.includes(dependent.key))) return false;
      } else {
        if (permission.dependencies && permission.dependencies.some(dependency => !this.rolePermissions.includes(dependency.key))) return false;
      }
      return true;
    }
  },
  computed: {
    utilities() {
      return utilities
    },
    allPermissionsJoined() {
      return this.allPermissions.modules ? Object.values(this.allPermissions.modules).flatMap(item => item.permissions) : [];
    }
  }
}
</script>